import { createSlice } from '@reduxjs/toolkit';
import { apiCallBegan } from 'client/store/middleware/api/api';
import { ICustomer } from 'common/interfaces/customer-interfaces';

const initialState = {
  isLoading: false,
  customers: [] as ICustomer[],
  selectedCustomer: null as ICustomer | null,
  error: null,
};

const customer = createSlice({
  name: 'customer',
  initialState,
  reducers: {
    customersRequested: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    customersRecieved: (state, action) => {
      state.isLoading = false;
      state.customers = action.payload;
    },
    customersFailed: (state, action) => {
      state.isLoading = false;
      state.error = action.payload.message;
    },
    customerSelected: (state, action) => {
      state.selectedCustomer = action.payload;
    },
    customerReset: (state) => {
      state.selectedCustomer = initialState.selectedCustomer;
    },
  },
});

export const {
  customersRequested,
  customersRecieved,
  customersFailed,
  customerSelected,
  customerReset,
} = customer.actions;

export default customer.reducer;

// @ts-ignore
export const getCustomers = () => apiCallBegan({
  url: '/customers',
  method: 'GET',
  onStart: customersRequested.type,
  // @ts-ignore
  onSuccess: (response) => ({
    type: customersRecieved.type,
    payload: response,
  }),
  onError: customersFailed.type,
});
